// Import necessary dependencies from React and Material-UI
import React from 'react';
import Grid2 from '@mui/material/Unstable_Grid2';
import Container from '@mui/material/Container';
import { Link } from 'react-router-dom';

// Import a custom function for scrolling to the top of the page
import scrollToTop from '../../../functions/scrollToTop';

// Import custom styles for the Footer component from an external CSS file
import './Footer.css';

/**
 * Footer component renders a footer section with links and information.
 * @returns {JSX.Element} - Footer component.
 */
const Footer = () => {
  return (
    <>
      {/* Footer container */}
      <div className="footer56">
        <Container maxWidth="lg">
          {/* Grid layout for organizing footer content */}
          <Grid2 container spacing={2}>
            {/* First column in the grid */}
            <Grid2 xs={12} sm={3} md={3} key={56}>
              <Link to="/">
                {/* Logo or site name with a link to the homepage */}
                <h3 onClick={scrollToTop}>InsightCoin</h3>
              </Link>
              <p>Analyze crypto coin stats in real time.</p>
            </Grid2>
            {/* Second column in the grid */}
            <Grid2 xs={12} sm={3} md={3} key={76}>
              <h4>Quick links</h4>
              {/* Links to different sections of the site */}
              <Link to="/">
                <p onClick={scrollToTop} className="link56">Home</p>
              </Link>
              <Link to="/coins">
                <p onClick={scrollToTop} className="link56">Coins</p>
              </Link>
              <Link to="/compare">
                <p onClick={scrollToTop} className="link56">Compare</p>
              </Link>
              <Link to="/starred">
                <p onClick={scrollToTop} className="link56">Starred</p>
              </Link>
            </Grid2>
            {/* Third column in the grid */}
            <Grid2 xs={12} sm={3} md={3} key={243}>
              <h4>Top coins</h4>
              {/* Links to specific coin pages */}
              <Link to="/coin/bitcoin">
                <p onClick={scrollToTop} className="link56">Bitcoin</p>
              </Link>
              <Link to="/coin/ethereum">
                <p onClick={scrollToTop} className="link56">Ethereum</p>
              </Link>
              <Link to="/coin/matic-network">
                <p onClick={scrollToTop} className="link56">Polygon</p>
              </Link>
            </Grid2>
            {/* Fourth column in the grid */}
            <Grid2 xs={12} sm={3} md={3} key={72}>
              <h4>Code base</h4>
              {/* Link to the GitHub repository */}
              <Link to="https://github.com/MoumitaMurmu/CryptoMasterApp" target='_blank'>
                <p className="link56">Github</p>
              </Link>
            </Grid2>
          </Grid2>
        </Container>
      </div>
    </>
  );
}

// Export the Footer component as the default export of the module
export default Footer;
